import { inject } from 'vue';
import type StateManager from '../StateManager';

const useStateManager = () => {
	const state = inject<StateManager>('stateManager');
	if (!state) {
		throw new Error('No state provided!');
	}
	return state;
};

export default useStateManager;
